import {
  addGrievanceTicketEndPoint,
  addGrievanceTicketReplyEndPoint,
  addUserGrievanceTicketReplyEndPoint,
  getAllGrievancePublicEndPoint,
  getAllGrievanceTicketEndPoint,
  getAllUserGrievanceTicketEndPoint,
  getAllUserNotificationEndPoint,
  getSingleGrievanceTicketEndPoint,
  getSingleUserGrievanceTicketEndPoint,
  updateStatusPriorityGrievanceTicketEndPoint,
  updateStatusPrioritypublicGrievanceTicketEndPoint,
} from "../../../config/adminUrlConfig";
import { ApiService, FileUploadService, BookingApiService } from "../../../config/apiServices";
import { GET_ALL_DISCOUNT_APPLICATIONS } from "../../../config/adminUrlConfig";



export const addGrievanceTicket = async (paylaod) => {
  try {
    return FileUploadService.post(addGrievanceTicketEndPoint, paylaod);
  } catch (error) {
    return error.message;
  }
};
export const getGrievanceAllTicket = async (paylaod) => {
  const { priority, status, search } = paylaod;
  let url = `${getAllGrievanceTicketEndPoint}?page=${paylaod?.currentpage}&`;
  if (priority) {
    url += `prority_level=${priority}&`;
  }
  if (status) {
    url += `status=${status}&`;
  }
  if (search) {
    url += `search=${search}&`;
  }
  return ApiService.get(url);
};

export const getpublicGrievance = async (paylaod) => {
  const { priority, status, search } = paylaod;
  let url = `${getAllGrievancePublicEndPoint}?page=${paylaod?.currentpage}&`;
  if (priority) {
    url += `priority=${priority}&`;
  }
  if (status) {
    url += `status=${status}&`;
  }
  if (search) {
    url += `search=${search}&`;
  }
  return ApiService.get(url);
};
export const getGrievanceAllUserTicket = async (paylaod) => {
  return ApiService.get(
    `${getAllUserGrievanceTicketEndPoint}?page=${paylaod?.currentpage}`
  );
};

export const getAllUserNotification = async (paylaod) => {
  return ApiService.post(
    `${getAllUserNotificationEndPoint}?page=${paylaod?.currentpage}`,
    {
      notification_for_id: 1,
      main_category_wise: paylaod?.decoded?.user_category_main,
      category_wise: paylaod?.decoded?.sub_category_type,
      sub_category_type:[paylaod?.decoded?.sub_category_type]
    }
  );
};

export const getSingleData = async (id) => {
  return ApiService.get(`${getSingleGrievanceTicketEndPoint}/${id}`);
};
export const getSingleUserData = async (id) => {
  return ApiService.get(`${getSingleUserGrievanceTicketEndPoint}/${id}`);
};
export const addSingleTicketResponse = async (FormData) => {
  return FileUploadService.post(addGrievanceTicketReplyEndPoint, FormData);
};

export const addUserSingleTicketResponse = async (FormData) => {
  return FileUploadService.post(addUserGrievanceTicketReplyEndPoint, FormData);
};

export const updateStausAndPriority = (payload) => {
  console.log(payload);
  return ApiService.post(
    `${updateStatusPriorityGrievanceTicketEndPoint}`,
    payload
  );
};
export const updatepublicStausAndPriority = (payload) => {
  return ApiService.post(
    `${updateStatusPrioritypublicGrievanceTicketEndPoint}`,
    payload
  );
};
